export default __webpack_public_path__ + "static/media/access_denied.f66a4aba.svg";